(() => {
  const initAbra = () => {
    const onetimeRadio = document.querySelector('[data-radio-onetime]');
    if (onetimeRadio && onetimeRadio.checked) {
      window.Abra.useSellingPlanPriceOnProductBlock = false;
      window.Abra.render();
    }
  };

  const attachListeners = () => {
    const subscribeRadio = document.querySelector('[data-radio-subsave]');
    const onetimeRadio = document.querySelector('[data-radio-onetime]');
    
    if (subscribeRadio) {
      subscribeRadio.addEventListener('change', function() {
        if (this.checked) {
          window.Abra.useSellingPlanPriceOnProductBlock = true;
          window.Abra.render();
        }
      });
    }
    
    if (onetimeRadio) {
      onetimeRadio.addEventListener('change', function() {
        if (this.checked) {
          window.Abra.useSellingPlanPriceOnProductBlock = false;
          window.Abra.render();
        }
      });
    }
  };

  const observer = new MutationObserver(() => {
    const rechargeContainer = document.querySelector('[data-widget-container-wrapper]');
    if (rechargeContainer) {
      initAbra();
      attachListeners();
      observer.disconnect();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
      initAbra();
      attachListeners();
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
    initAbra();
    attachListeners();
  }
})();


// Cart Auto-Refresh
(() => {
  let isRefreshing = false;
  let refreshTimeout = null;

  const refreshCart = () => {
    if (refreshTimeout) {
      clearTimeout(refreshTimeout);
    }

    refreshTimeout = setTimeout(() => {
      if (isRefreshing) return;
      
      isRefreshing = true;
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(() => {
        isRefreshing = false;
      }, 2000);
    }, 1200);
  };

  document.addEventListener("cart:change", (event) => {
    if (!isRefreshing) {
      refreshCart();
    }
  });

  document.addEventListener("variant:add", () => {
    if (!isRefreshing) {
      refreshCart();
    }
  });

  document.addEventListener("line-item:change", () => {
    if (!isRefreshing) {
      refreshCart();
    }
  });
})();